import {
  AirType,
  AirMetricType,
  AnalyticsGatewayService,
} from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { FeatureMockRouter } from '@frontend/demo-interceptors';
import { MockAPIRouter } from '@frontend/fetch';
import { mairAggregatesDummyData } from '../configs/messaging-air/aggregate-data';
import { topConversationOutcomesDummyData } from '../configs/messaging-air/ai-conversation-outcomes-data';
import { aiConversationsDummyData, aiConversationsDummyDataNew } from '../configs/messaging-air/ai-conversations-data';
import { staffTransferredConversationsDummyData } from '../configs/messaging-air/staff-transferred-conversations-data';
import { tasksCreatedByAirDummyData } from '../configs/messaging-air/tasks-created-by-air-data';
import { topConversationIntentDummyData } from '../configs/messaging-air/top-conversation-intent-data';
import { vairAggregatesDummyData } from '../configs/voice-air/aggregate-data';
import { followUpTasksDummyData } from '../configs/voice-air/follow-up-tasks-data';
import { staffTransferredCallDummyData } from '../configs/voice-air/staff-transfered-calls-data';
import { AirDemoMockRouterContext } from './types';

const AGGREGATES_MOCK_DATA_MAP = {
  [AirType.MAIR]: mairAggregatesDummyData,
  [AirType.VAIR]: vairAggregatesDummyData,
};

const MOCK_DATA_MAP: Partial<Record<AirMetricType, object | ((payload: any) => object)>> = {
  [AirMetricType.FOLLOW_UP_TASKS]: followUpTasksDummyData,
  [AirMetricType.STAFF_TRANSFERED_CALLS]: staffTransferredCallDummyData,
  [AirMetricType.AI_THREADS]: aiConversationsDummyData,
  [AirMetricType.AI_CONVERSATIONS]: aiConversationsDummyDataNew,
  [AirMetricType.STAFF_TRANSFERS]: staffTransferredConversationsDummyData,
  [AirMetricType.INTENTS]: topConversationIntentDummyData,
  [AirMetricType.OUTCOMES]: topConversationOutcomesDummyData,
  [AirMetricType.TOTAL_TASKS]: tasksCreatedByAirDummyData,
};

export const AirMockRouter: FeatureMockRouter<AirDemoMockRouterContext> = {
  addMockRouterEndpoints: (router) => {
    // GetAirAggregates endpoint mock
    router.schemaEndpoint(AnalyticsGatewayService.GetAirAggregates, async (request, _) => {
      // Return placeholder response structure:
      const payload = await request.clone().json();
      const relevantMockData = AGGREGATES_MOCK_DATA_MAP[payload.airType as AirType];
      return MockAPIRouter.json(relevantMockData);
    });

    // GetAirAggregates endpoint mock - for V1 api
    router.schemaEndpoint(AnalyticsGatewayService.GetAirAggregatesV1, async (request, _) => {
      // Return placeholder response structure:
      const payload = await request.clone().json();
      const relevantMockData = AGGREGATES_MOCK_DATA_MAP[payload.airType as AirType];
      return MockAPIRouter.json(relevantMockData);
    });

    // GetAirData endpoint mock
    router.schemaEndpoint(AnalyticsGatewayService.GetAirData, async (request, _) => {
      // Return placeholder response structure:
      const payload = await request.clone().json();
      let relevantMockData = MOCK_DATA_MAP[payload.metricType as AirMetricType];
      if (typeof relevantMockData === 'function') {
        relevantMockData = relevantMockData(payload);
      }
      return MockAPIRouter.json(relevantMockData);
    });
  },

  invalidateQueries: (queryClient) => {
    queryClient.invalidateQueries(['AnalyticsGatewayV1', 'GetAirAggregates']);
    queryClient.invalidateQueries(['AnalyticsGatewayV1', 'GetAirData']);
  },
};
